import ProviderDocsTable from "../../components/ProviderDocsTable";
import { Row, Col, Card, CardTitle, CardBody } from "reactstrap";

const ManageProviders = () => {
  return (
    <Row>
      {/* --------------------------------------------------------------------------------*/}
      {/* Provider Documents Management Table*/}
      {/* --------------------------------------------------------------------------------*/}
      <Col lg="12">
        <Card>
          <CardTitle tag="h6" className="border-bottom p-3 mb-0">
            <i className="bi bi-building me-2"> </i>
            Pending Provider Applications & Document Review
          </CardTitle>
          <CardBody className="">
            <ProviderDocsTable/>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default ManageProviders;